export const API_URL = 'https://prod-api-chat.tomi.com/';

// 🔹 Session timing configuration
export const isProd = "production";